import React from 'react';
import type { AmhsLiveReportPayload } from '../../types/amhsStream';
import {
  liveDispatchMetrics,
  liveReportKpis,
  liveReportRunStatus,
} from '../../features/simulation/liveDispatchReport';

type LiveDispatchReportPanelProps = {
  report: AmhsLiveReportPayload | null;
  dispatchLabel: string;
  compact?: boolean;
};

const LiveDispatchReportPanel: React.FC<LiveDispatchReportPanelProps> = ({
  report,
  dispatchLabel,
  compact = false,
}) => {
  const kpis = liveReportKpis(report);
  const metrics = liveDispatchMetrics(kpis);
  const runStatus = liveReportRunStatus(report);

  if (!report || metrics.length === 0) {
    return (
      <p className="text-[10px] leading-relaxed text-emerald-800/80">
        Dispatch KPIs will appear once the live stream publishes its first progress report.
      </p>
    );
  }

  return (
    <div className={compact ? 'space-y-1.5' : 'space-y-2'}>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="rounded-full bg-emerald-700 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white">
          {dispatchLabel}
        </span>
        {runStatus && (
          <span className="rounded-full bg-white/80 px-2 py-0.5 text-[9px] font-medium text-emerald-900 ring-1 ring-emerald-200">
            {runStatus === 'final' ? 'Final' : 'In progress'}
          </span>
        )}
      </div>
      <dl className={`grid gap-x-3 gap-y-1 ${compact ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-3'}`}>
        {metrics.map(({ label, value }) => (
          <div key={label} className="min-w-0">
            <dt className="truncate text-[9px] text-emerald-800/80">{label}</dt>
            <dd className="text-[10px] font-medium tabular-nums text-emerald-950">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default LiveDispatchReportPanel;
